import {
  Box,
  Checkbox,
  Flex,
  HStack,
  IconButton,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  PaginationState,
  SortingState,
  useReactTable,
} from "@tanstack/react-table";
import { apiurl } from "APIURL";
import axios from "axios";
// Custom components
import Card from "components/card/Card";
import Menu from "components/menu/MainMenu";
import * as React from "react";
// Assets
import {
  AiOutlineCheck,
  AiOutlineClose,
  AiOutlineEdit,
  AiOutlineExclamation,
} from "react-icons/ai";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getCourses, setGlobalCourses } from "redux/slices/coursesSlice";
import { getFormations, setFormations } from "redux/slices/formationsSlice";
import { setFormationToUpdate } from "redux/slices/updateFormationSlice";

type RowObj = {
  id: number;
  title: string;
  description: string;
  addedOn: Date;
  stagiarePrice: number;
  professionalPrice: number;
  lastModifiedOn: Date;
  isVerified: boolean;
  actions: any;
};

const columnHelper = createColumnHelper<RowObj>();

// const columns = columnsDataCheck;
export default function FormationsTable(props: {
  tableData: RowObj[];
  loading: boolean;
}) {
  const { tableData, loading } = props;
  const [sorting, setSorting] = React.useState<SortingState>([]);
  const [pagination, setPagination] = React.useState<PaginationState>({
    pageIndex: 0,
    pageSize: 0,
  });
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const history = useHistory();

  const [checkedItems, setCheckedItems] = React.useState([]);
  const dispatch = useAppDispatch();
  const formations = useAppSelector(getFormations).formations;
  const courses = useAppSelector(getCourses).courses;
  let defaultData = tableData;
  const token = localStorage.getItem("token");
  const navigateToUpdate = (id: number) => {
    dispatch(setFormationToUpdate(formations.find((item) => item.id === id)));
    history.push("/formations/update");
  };
  const verifyFormation = async (id: number) => {
    try {
      console.log(id);

      const res = await axios.patch(
        `${apiurl}/formation/verify/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(res.data);
      dispatch(
        setFormations([
          ...formations.filter((item) => item.id !== res.data.id),
          res.data,
        ])
      );
      dispatch(
        setGlobalCourses(courses.filter((item) => item.formationId != id))
      );
    } catch (error) {
      console.log(error);
    }
  };
  const deleteFormation = async (id: number) => {
    try {
      console.log(id);

      const res = await axios.delete(`${apiurl}/formation/${id}`);
      console.log(res.data);
      dispatch(
        setFormations([...formations.filter((item) => item.id !== res.data.id)])
      );
    } catch (error) {
      console.log(error);
    }
  };
  const columns = [
    columnHelper.accessor("title", {
      id: "title",
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: "10px", lg: "12px" }}
          color="gray.400"
        >
          Designation de formation
        </Text>
      ),
      cell: (info: any) => (
        <Flex align="center">
          <Checkbox colorScheme="brandScheme" me="10px" />
          <Text color={textColor} fontSize="sm" fontWeight="700">
            {info.getValue()}
          </Text>
        </Flex>
      ),
    }),
    columnHelper.accessor("description", {
      id: "description",
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: "10px", lg: "12px" }}
          color="gray.400"
        >
          Description
        </Text>
      ),
      cell: (info) => (
        <Flex align="center">
          <Text color={textColor} fontSize="sm" fontWeight="700">
            {info.getValue()}
          </Text>
        </Flex>
      ),
    }),
    columnHelper.accessor("addedOn", {
      id: "addedOn",
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: "10px", lg: "12px" }}
          color="gray.400"
        >
          Ajouté le
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" fontWeight="700">
          {new Date(info.getValue()).toLocaleDateString("fr-FR", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </Text>
      ),
    }),
    columnHelper.accessor("stagiarePrice", {
      id: "stagiarePrice",
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: "10px", lg: "12px" }}
          color="gray.400"
        >
          Prix pour stagiaires (DT)
        </Text>
      ),
      cell: (info) => (
        <Flex align="center">
          {/*<Progress variant='table' colorScheme='brandScheme' h='8px' w='108px' value={info.getValue()} />
           */}
          <Text color={textColor} fontSize="sm" fontWeight="700">
            {info.getValue()}
          </Text>
        </Flex>
      ),
    }),
    columnHelper.accessor("professionalPrice", {
      id: "professionalPrice",
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: "10px", lg: "12px" }}
          color="gray.400"
        >
          Prix pour profissionnels (DT)
        </Text>
      ),
      cell: (info) => (
        <Flex align="center">
          {/*<Progress variant='table' colorScheme='brandScheme' h='8px' w='108px' value={info.getValue()} />
           */}
          <Text color={textColor} fontSize="sm" fontWeight="700">
            {info.getValue()}
          </Text>
        </Flex>
      ),
    }),
    columnHelper.accessor("isVerified", {
      id: "isVerified",
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: "10px", lg: "12px" }}
          color="gray.400"
        >
          Verifié
        </Text>
      ),
      cell: (info) => (
        <Flex align="center">
          {/*<Progress variant='table' colorScheme='brandScheme' h='8px' w='108px' value={info.getValue()} />
           */}
          <Text color={textColor} fontSize="sm" fontWeight="700">
            {info.getValue() === true ? (
              <AiOutlineCheck size={18} color="green" />
            ) : (
              <AiOutlineExclamation size={18} color="red" />
            )}
          </Text>
        </Flex>
      ),
    }),
    columnHelper.accessor("actions", {
      id: "actions",
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: "10px", lg: "12px" }}
          color="gray.400"
        >
          Actions
        </Text>
      ),
      cell: (info: any) => (
        <Flex align="center">
          <HStack spacing="2">
            <IconButton
              variant={"solid"}
              onClick={() => navigateToUpdate(info.row.original.id)}
              icon={<AiOutlineEdit />}
              colorScheme="brandScheme"
              aria-label={"Modifier"}
            />
            <IconButton
              onClick={() => verifyFormation(info.row.original.id)}
              icon={<AiOutlineCheck />}
              colorScheme="brandScheme"
              aria-label={"Verifier"}
            />
            <IconButton
              onClick={() => deleteFormation(info.row.original.id)}
              icon={<AiOutlineClose />}
              colorScheme="gray"
              aria-label={"Supprimer"}
            />
          </HStack>
        </Flex>
      ),
    }),
  ];
  //const formations = useAppSelector(getFormations).formations
  const [data, setData] = React.useState(() => [...defaultData]);
  console.log(data);
  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
      pagination,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    pageCount: -1,
    debugTable: true,
    paginateExpandedRows: true,
    onPaginationChange: setPagination,
  });
  //setData(defaultData)
  React.useEffect(() => {
    const reRender = () => {
      setData(defaultData);
    };
    reRender();
  });
  return (
    <Card
      flexDirection="column"
      w="100%"
      px="0px"
      overflowX={{ sm: "scroll", lg: "hidden" }}
    >
      <Flex px="25px" mb="8px" justifyContent="space-between" align="center">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
        >
          Liste des formations
        </Text>
        <Menu />
      </Flex>
      <Box>
        <Table variant="simple" color="gray.500" mb="24px" mt="12px">
          <Thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <Tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => {
                  return (
                    <Th
                      key={header.id}
                      colSpan={header.colSpan}
                      pe="10px"
                      borderColor={borderColor}
                      cursor="pointer"
                      onClick={header.column.getToggleSortingHandler()}
                    >
                      <Flex
                        justifyContent="space-between"
                        align="center"
                        fontSize={{ sm: "10px", lg: "12px" }}
                        color="gray.400"
                      >
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                        {{
                          asc: "",
                          desc: "",
                        }[header.column.getIsSorted() as string] ?? null}
                      </Flex>
                    </Th>
                  );
                })}
              </Tr>
            ))}
          </Thead>
          <Tbody>
            {loading === true ? (
              <Spinner color="brand.500" />
            ) : (
              table
                .getRowModel()
                .rows.slice(0, 50)
                .map((row) => {
                  return (
                    <Tr key={row.id}>
                      {row.getVisibleCells().map((cell) => {
                        return (
                          <Td
                            key={cell.id}
                            fontSize={{ sm: "14px" }}
                            minW={{ sm: "150px", md: "200px", lg: "auto" }}
                            borderColor="transparent"
                          >
                            {flexRender(
                              cell.column.columnDef.cell,
                              cell.getContext()
                            )}
                          </Td>
                        );
                      })}
                      ,
                    </Tr>
                  );
                })
            )}
          </Tbody>
        </Table>
      </Box>
    </Card>
  );
}
